autoDisposeTimeoutMs